module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker50-api.relevant-digital.com/"}};